import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Profile } from 'src/model/profile.model';

interface PossibleSharedProfile {
  companyCode: string,
  companyId: number,
  customerId: number,
  customerName: string,
  icNumber: string,
  profileId: number,
  requestApprovalInterval: string;
}

@Component({
    selector: 'app-share-profile-to-company',
    templateUrl: './share-profile-to-company.component.html',
    styleUrls: ['./share-profile-to-company.component.scss'],
    standalone: false
})
export class ShareProfileToCompanyComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);


  profileIdToShare: number;
  disabledSubmit = false;
  @Input() currentProfile: Profile;
  possibleSharedProfileList: PossibleSharedProfile[] = [];
  manualKeyInSharedId = false;

  ngOnInit(): void {
    this.getProfilePossibleSharedProfiles();
  }

  changeManualKeyInBoolean() {
    !this.manualKeyInSharedId;
    this.profileIdToShare = undefined;
  }

  validateInput() {
    if (this.profileIdToShare == undefined)
      this.sharedService.openAlert("Please key in profile ID to share!", ALERT_TYPE.DANGER);
    else
      this.confirmBeforeShare();
  }

  sharePossibleProfile(profileId: number) {
    this.profileIdToShare = profileId;
    this.confirmBeforeShare();
  }

  confirmBeforeShare() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to share this profile to " + this.profileIdToShare + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.shareProfile();
    });
  }

  getProfilePossibleSharedProfiles() {
    const xhttp = this.restApi.getRequest(this.constructApi.getProfilePossibleSharedProfile(this.currentProfile.ID));
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const jsonArray = JSON.parse((xhttp.responseText));

        jsonArray.forEach(json => {
          const possibleProfile = { companyCode: json.companyCode, companyId: json.companyId, customerId: json.customerId, customerName: json.customerName, icNumber: json.icNumber, profileId: json.profileId, requestApprovalInterval: json.requestApprovalInterval }
          this.possibleSharedProfileList.push(possibleProfile)
        }
        );
      }
    };
  }

  shareProfile() {
    const xhr = this.restApi.patchRequest(this.constructApi.getShareProfileToAnotherProfile(Number(this.currentProfile.ID), Number(this.profileIdToShare)));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          //if success emit
          // this.passEntry.emit();
          window.location.reload();
          this.closeModal();
          this.sharedService.openAlert("Successfully shared profile!", ALERT_TYPE.SUCCESS)
        }
        else {
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }
}
